<template>
  <el-select
      v-model="selectedCutoffGroup"
      @input="emitInput()"
      @change="emitChange()"
      ref="cutoff-group-select"
      v-bind:multiple="multiple"
      v-bind:collapse-tags="multiple"
  >
    <el-option
        v-for="cutoffGroup in cutoffGroups"
        :key="cutoffGroup.id"
        :label="cutoffGroup.name"
        :value="cutoffGroup.id"
    ></el-option>
  </el-select>
</template>

<script>
import shipperCutoffGroupService from '@/api/shipperCutoffGroupService';

const shipperCutoffGroupNone = 0;

export default {
  name: 'ShipperCutoffGroup',
  props: ['value', 'includeOptionAll', 'includeOptionNone', 'multiple'],
  watch: {
    value(newValue) {
      this.selectedCutoffGroup = newValue;
    },
  },
  data() {
    return {
      selectedCutoffGroup: this.value,
      cutoffGroups: [],
    };
  },
  mounted() {
    if (this.includeOptionAll) {
      this.cutoffGroups.push({
        id: null,
        name: this.$t('common.all')
      });
    }

    if (this.includeOptionNone) {
      this.cutoffGroups.push({
        id: shipperCutoffGroupNone,
        name: this.$t('common.none')
      });
    }

    shipperCutoffGroupService.search({
      pageResults: false
    }).then((response) => {
      this.cutoffGroups = this.cutoffGroups.concat(
        response.data.map(cutoffGroup => ({
          id: cutoffGroup.id,
          name: cutoffGroup.name
        }))
      );
    });
  },
  methods: {
    emitInput() {
      this.$emit('update:value', this.selectedCutoffGroup);
      this.$emit('input', this.selectedCutoffGroup);
    },
    emitChange() {
      this.$emit('update:value', this.selectedCutoffGroup);
      this.$emit('change', this.selectedCutoffGroup);
    },
    setSelectedShipperCutoffGroup(selected) {
      this.selectedCutoffGroup = selected;
    },
  },
};
</script>
